<template>
	<div>
		<slot name="header"></slot>		
		<div class="form-group form__item" :class="{ 'form-group--error': v.$error }">
			<password-group @change="emit('input', pin)" v-model="pin" id="pin" name="pin"
			                :placeholder="'Enter Your Pin' | trans"
			                :className="status(v)"
			                :reset="resetPin"
							:message='message'
			                :lock="lock"
			                keyboard="true"
			>
				<ul class="pinGroup__messages invalid-feedback list-unstyled" v-if="v.$error">
					<li v-if="!v.required">
						{{'Pin required' | trans}}
					</li>
					<li v-if="!v.minLength">
						{{'Pin length must be at least 4 characters' | trans}}
					</li>
					<li v-if="!v.maxLength">
						{{'Pin length may not be greater than 4 characters' | trans}}
					</li>
					<li v-if="!v.integer">
						{{'Pin must contain only digits' | trans}}
					</li>
					<li v-if="message">
						<slot name='info'></slot>
					</li>
				</ul>
			</password-group>
			<form-errors :field-name="'pin'" />
		</div>
		<div class="form-group form__item" v-if="!hidePinButton">
			<div class="clearfix">
				<div class="float-left" v-if="cancelButton">
					<b-button @click.prevent="$emit('pinDialogCancel', $event)"
					          :disabled="lock">{{'Cancel' | trans}}</b-button>
				</div>
				<div class="float-right">
					<spinner-button :className="'btn btn-danger'" @click.prevent="$emit('pinDialogSubmit', $event)"
					                :is-pending="lock">
						{{'Validate Pin' | trans}}
					</spinner-button>
				</div>
			</div>
		</div>
		<div v-else>
			{{'Please wait ...' | trans}}
		</div>
		<slot name="footer"></slot>
	</div>
</template>

<script>
	export default {
		props: ['v', 'lock', 'hidePinButton', 'cancelButton', 'message'],
		data() {
			return {
				pin: '',
				resetPin: false
			}
		},
		watch: {
			pin() {
				this.$emit('input', this.pin)
			},
		},
		methods: {
			input(data) {
				this.$emit('input', data);
			},
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/pin-group.vue